var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.notice
    ? _c(
        "div",
        { staticClass: "content_box mt10" },
        [
          _vm.notice.calculation
            ? [
                _c("span", { staticClass: "content_title_span" }, [
                  _vm._v("Freetime Calculation"),
                ]),
                _c("div", { staticClass: "cont text_left" }, [
                  _c(
                    "ul",
                    {
                      staticClass: "bul_list_sm",
                      staticStyle: { "list-style": "none" },
                    },
                    [
                      _c(
                        "li",
                        [
                          _vm._l(_vm.notice.calculation, function (line, i) {
                            return [
                              _vm._v(_vm._s(line)),
                              _c("br", { key: "calc-" + i }),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.notice.calculation && _vm.notice.precautions
            ? _c("br")
            : _vm._e(),
          _vm.notice.precautions
            ? [
                _c("span", { staticClass: "content_title_span" }, [
                  _vm._v("Precautions"),
                ]),
                _c("div", { staticClass: "cont text_left" }, [
                  _c(
                    "ul",
                    {
                      staticClass: "bul_list_sm",
                      staticStyle: { "list-style": "none" },
                    },
                    [
                      _c(
                        "li",
                        [
                          _vm._l(_vm.notice.precautions, function (line, i) {
                            return [
                              _vm._v(_vm._s(line)),
                              _c("br", { key: "prec-" + i }),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }